import { useNavigate, useLocation } from "react-router-dom";

export const useGestureToScroll = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const addScrollIndexInListingUrl = (scrollIndex: number) => {
        if (
            location?.pathname &&
            scrollIndex !== undefined &&
            !isNaN(scrollIndex)
        ) {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set("scrollTo", scrollIndex.toString());
            navigate(
                {
                    pathname: location.pathname,
                    search: searchParams.toString(),
                },
                { replace: true },
            );
        }
    };

    return { addScrollIndexInListingUrl };
};
